/** A digit run ("1,200", "45.2", "05") or the "no data" dash, then anything else (units, slashes, spaces). */
const RUNS = /(\d[\d,.]*|-)|([^\d-]+)/g;

/**
 * Prints a formatted value ("1,200 XP", "12h 05m", "45.2%") with the numbers as LCD digits and the rest
 * (units, separators) as small caps. DSEG7 has no percent sign or slash, so those never reach the LCD face, and its
 * decimal point is a speck, so numbers with one use the UI face (`lcd--dec`).
 */
export function Lcd({ text }: { text: string }) {
  const runs = [];
  let i = 0;
  for (const match of text.matchAll(RUNS)) {
    runs.push(
      match[1] !== undefined ? (
        <span key={i} class={match[1].includes(".") ? "lcd lcd--dec" : "lcd"}>
          {match[1]}
        </span>
      ) : (
        <span key={i} class="profile__unit">
          {match[2]}
        </span>
      ),
    );
    i += 1;
  }
  return <>{runs}</>;
}
